import {StyleParamType, createStylesParams, wixColorParam, wixFontParam} from '@wix/tpa-settings';
import {StyleType, wixColor, wixFont, CssColor, CssFont} from '@wix/editor-platform-ooi-metadata-resolver';

export enum CartWidgetParamNames {
  CART_WIDGET_CART_ICON_TEXT = 'cartWidget_cartIconText',
  CART_WIDGET_CART_ICON_TEXT_FONT = 'cartWidget_cartIconTextFont',
  CART_WIDGET_CART_ICON_NUMBER = 'cartWidget_cartIconNumber',
  CART_WIDGET_CART_ICON_NUMBER_FONT = 'cartWidget_cartIconNumberFont',
  CART_WIDGET_CART_ICON_BUBBLE = 'cartWidget_cartIconBubble',
  CART_WIDGET_CART_ICON = 'cartWidget_cartIcon',
  CART_WIDGET_ICON = 'cartWidgetIcon',
}

const ICONS_WITH_TEXT_WITHOUT_BACKGROUND = [1, 3, 6, 10, 11];
const DEFAULT_CART_WIDGET_ICON = 1;
const CART_WIDGET_ICON_PARAM = {type: StyleParamType.Number, key: CartWidgetParamNames.CART_WIDGET_ICON} as const;

export type IStylesParams = {
  cartIconTextFont: StyleParamType.Font;
  cartIconTextColor: StyleParamType.Color;
  cartIconBubbleColor: StyleParamType.Color;
  cartIconColor: StyleParamType.Color;
  cartIconNumberFont: StyleParamType.Font;
  cartIconNumberColor: StyleParamType.Color;
};

export default createStylesParams<IStylesParams>({
  cartIconBubbleColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_BUBBLE,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Color of the bubble background that displays the cart item count.',
      },
    },
  },
  cartIconColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Color of the cart icon.',
      },
    },
  },
  cartIconTextFont: {
    type: StyleParamType.Font,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_TEXT_FONT,
    getDefaultValue: wixFontParam('Body-M', {
      size: 90,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: wixFont(CssFont.WstParagraph1Font),
      ai: {
        description: 'Font of the title text of the cart icon.',
      },
    },
  },
  cartIconTextColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_TEXT,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Color of the title text of the cart icon.',
      },
    },
  },
  cartIconNumberFont: {
    type: StyleParamType.Font,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_NUMBER_FONT,
    getDefaultValue: wixFontParam('Body-M', {
      size: 90,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: wixFont(CssFont.WstParagraph1Font),
      ai: {
        description: 'Font of the number text displayed on the cart icon.',
      },
    },
  },
  cartIconNumberColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_NUMBER,
    getDefaultValue: (params) => {
      const cartWidgetIcon = params.getStyleParamValue(CART_WIDGET_ICON_PARAM as any, {}) || DEFAULT_CART_WIDGET_ICON;
      const colorReference = ICONS_WITH_TEXT_WITHOUT_BACKGROUND.includes(cartWidgetIcon) ? 'color-1' : 'color-8';
      return wixColorParam(colorReference)(params);
    },
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
      ai: {
        description: 'Color of the number text displayed on the cart icon.',
      },
    },
  },
});
